import { render, staticRenderFns } from "./NewTransmitterReplacementEvent.vue?vue&type=template&id=8421a880&scoped=true&"
import script from "./NewTransmitterReplacementEvent.vue?vue&type=script&lang=js&"
export * from "./NewTransmitterReplacementEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8421a880",
  null
  
)

export default component.exports